import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var VideoItemService;
(function (VideoItemService) {
    VideoItemService.SYMBOL = Symbol.for('VideoItemService');
})(VideoItemService || (VideoItemService = {}));
export default (container) => {
    let VideoItemServiceImpl = class VideoItemServiceImpl {
        async items() {
            const res = await fetch('/datas/english/items.json');
            const data = await res.json();
            return data.reverse();
        }
        async item(name) {
            const items = await this.items();
            return items.find(item => item.name === name);
        }
    };
    VideoItemServiceImpl = __decorate([
        Sim({ symbol: VideoItemService.SYMBOL, container: container })
    ], VideoItemServiceImpl);
    return VideoItemServiceImpl;
};
